// Variable globale pour mémoriser la dernière variante sélectionnée
let lastSelectedUpsellVariant = null;

/**
 * Met à jour le compteur du panier dans le header.
 */
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const countElem = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      if (countElem) {
        countElem.textContent = cart.item_count;
      }
    })
    .catch(err => console.error('Erreur lors de la mise à jour du compteur :', err));
}

/**
 * Met à jour la visibilité du bloc upsell dans le cart drawer.
 * Si aucun upsell n'est présent dans le panier, le bloc est affiché,
 * le toggle est réinitialisé et on force la mise à jour du prix.
 */
function updateUpsellVisibility(cart) {
  const upsellVariants = ["55608367808841"];
  const upsellInCart = cart.items.some(item => upsellVariants.includes(item.id.toString()));
  const upsellBlock = document.querySelector('.cart-upsell');
  if (upsellBlock) {
    if (upsellInCart) {
      upsellBlock.style.display = "none";
      console.log("updateUpsellVisibility: Upsell présent, bloc masqué");
    } else {
      upsellBlock.style.display = "flex";
      // Réinitialiser le toggle
      const upsellToggle = document.getElementById("upsell-toggle");
      if (upsellToggle) {
        upsellToggle.checked = false;
      }
      console.log("updateUpsellVisibility: Upsell absent, bloc affiché et toggle réinitialisé");
      // Met à jour le prix pour la variante actuellement sélectionnée.
      updateUpsellPriceDisplay();
    }
  }
}

/**
 * Mapping des prix pour "Assurance Livraison".
 * Les valeurs ont été mises à jour aux prix corrects.
 */
const upsellPricing = {
  "55608367808841": { price: "3,95€", compare: "" }
};

/**
 * Met à jour l'affichage des prix dans le bloc upsell en fonction de la variante sélectionnée.
 * Les éléments avec les IDs "upsell-price" et "upsell-compare-price" doivent exister dans votre snippet.
 */
function updateUpsellPriceDisplay() {
  const selectElem = document.getElementById("upsell-variant");
  if (selectElem) {
    // On mémorise la sélection
    lastSelectedUpsellVariant = selectElem.value;
    const pricing = upsellPricing[selectElem.value];
    if (pricing) {
      const priceElem = document.getElementById("upsell-price");
      const compareElem = document.getElementById("upsell-compare-price");
      if (priceElem) {
        priceElem.textContent = pricing.price;
      }
      if (compareElem) {
        compareElem.textContent = pricing.compare;
      }
      console.log("updateUpsellPriceDisplay: Prix mis à jour pour le variant", selectElem.value, pricing);
    }
  }
}

/**
 * Attache un écouteur sur le sélecteur de variante.
 * Si une valeur a été mémorisée, le sélecteur est réinitialisé à cette valeur avant d'appeler updateUpsellPriceDisplay().
 */
function attachUpsellVariantChange() {
  const selectElem = document.getElementById("upsell-variant");
  if (selectElem) {
    if (lastSelectedUpsellVariant) {
      selectElem.value = lastSelectedUpsellVariant;
    }
    selectElem.addEventListener("change", function() {
      lastSelectedUpsellVariant = selectElem.value;
      updateUpsellPriceDisplay();
    });
    updateUpsellPriceDisplay();
  } else {
    console.log("attachUpsellVariantChange : élément upsell-variant non trouvé");
  }
}

/**
 * Gestion globale des changements sur le sélecteur de variante et sur le toggle upsell via délégation.
 */
document.addEventListener("change", function(event) {
  // Si le sélecteur de variante change
  if (event.target && event.target.id === "upsell-variant") {
    lastSelectedUpsellVariant = event.target.value;
    updateUpsellPriceDisplay();
  }
  // Si le toggle upsell change
  if (event.target && event.target.id === "upsell-toggle") {
    const variantElem = document.getElementById("upsell-variant");
    if (!variantElem) return;
    const variantId = variantElem.value;
    const isChecked = event.target.checked;
    if (isChecked) {
      // Ajouter le produit upsell
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(response => response.json())
      .then(data => {
        console.log("Upsell ajouté :", data);
        refreshCartDrawer();
      })
      .catch(error => console.error("Erreur lors de l'ajout de l'upsell :", error));
    } else {
      // Retirer le produit upsell
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: { [variantId]: 0 } })
      })
      .then(response => response.json())
      .then(data => {
        console.log("Upsell retiré :", data);
        refreshCartDrawer();
      })
      .catch(error => console.error("Erreur lors de la suppression de l'upsell :", error));
    }
  }
});

/**
 * Rafraîchit le contenu du cart drawer.
 * Après rafraîchissement, met à jour la visibilité du bloc upsell, le compteur et réattache le sélecteur.
 */
function refreshCartDrawer() {
  fetch(`${routes.cart_url}?section_id=cart-drawer&t=${Date.now()}`)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('cart-drawer');
      if (newDrawer) {
        document.querySelector('cart-drawer').outerHTML = newDrawer.outerHTML;
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      }
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          updateUpsellVisibility(cart);
          updateCartCount();
          attachUpsellVariantChange();
        });
    })
    .catch(err => console.error('Erreur lors du rafraîchissement du cart drawer :', err));
}

/**
 * Attachement initial au chargement du document.
 */
document.addEventListener("DOMContentLoaded", function() {
  attachUpsellVariantChange();
});
